import { render, staticRenderFns } from "./NetworkSecurityInternetGeneralInformation.vue?vue&type=template&id=48ada822&scoped=true&"
import script from "./NetworkSecurityInternetGeneralInformation.vue?vue&type=script&lang=ts&"
export * from "./NetworkSecurityInternetGeneralInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ada822",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCol,VForm,VRow,VSelect,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48ada822')) {
      api.createRecord('48ada822', component.options)
    } else {
      api.reload('48ada822', component.options)
    }
    module.hot.accept("./NetworkSecurityInternetGeneralInformation.vue?vue&type=template&id=48ada822&scoped=true&", function () {
      api.rerender('48ada822', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/requirement/network-security-internet/components/NetworkSecurityInternetGeneralInformation.vue"
export default component.exports